// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"220":"7ae6dd0a","274":"1be17639","288":"8c172ba8","461":"18402cde","577":"f7bb91a1","729":"1b3d5fbe","815":"0b03e3a3","976":"21e20a4e"}[chunkId] + ".js";
};